<template>
  <div class="footer">
    <div class="copyright" style="position: absolute; bottom:1vh; left:50vw; transform: translate(-50%)">
      Copyright
      <a-icon type="copyright" />
      <span v-html="copyright" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  // eslint-disable-next-line vue/require-prop-types
  props: ['copyright']
}
</script>

<style lang="less" scoped>
  .footer {
    // padding: 0 16px;
    margin-top: 46%;
    text-align: center;

    .copyright {
      color: #fff;
      font-size: 14px;
      i {
        font-size: .8rem !important;
      }
    }

    &a {
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/GlobalFooter.vue